import React from 'react'

export const ThanksCmp = () => {

    // function abrirInstagram(btn) {
    //     const url = 'https://www.instagram.com/lentelibrephotography/'
    //     window.location.href = url;
    // }
     function abrirFacebook(btn) {
        const url = 'https://www.facebook.com/lentelibre'
        window.location.href = url;
    }
    return (
        <div >
            <h2 className="text-3xl font-bold mb-10">GRACIAS</h2>
            <div className="mb-5">
            <p className="text-2xl font-bold mb-5">
                    Nos pondremos en contacto con usted dentro de las próximas 48 horas para ver los detalles de la fecha y terminar de agendar su sesión.
                </p>
                <p className="text-2xl">
                    Siganos en facebook para ver nuestros anteriores trabajos presionando el boton debajo
                </p>
            </div>
            <div className="flex justify-center">
                <div style={{ width: '50%' }} className="flex flex-col">
                    <button className="btn btn-secondary" onClick={abrirFacebook}>Facebook</button>
                </div>
            </div>
        </div>
    )
}
